import Chart from "chart.js/dist/chart.js"
import ChartDataLabels from "chartjs-plugin-datalabels"

// What?
// this.handleEvent("analyse-results", (event) => {
//     event.results.forEach((results) => {
//         chart.data.datasets.forEach((dataset) => {
//             trade.executed_at = new Date(Date.parse(trade.executed_at))
//             dataset.data.push(trade)
//         })
//     })
//     chart.update();
// });


const reducer = (accumulator, curr) => accumulator + curr;
const percentage_of = (num, total) => {
  let percentage = (num / total) * 100;
  return percentage.toPrecision(2);
}

function registerChart() {
  Chart.register(
    [
      ChartDataLabels,
      {
        id: "inner-text",
        beforeDraw: function(chart) {
          if (chart.data.chartType == "doughnut") {
            var text = `${chart.data.totalEntries}`

            if (text != 0 || text != "0") {
              var width = chart.chartArea.width,
                  height = chart.chartArea.height,
                  ctx = chart.ctx;

              ctx.restore();
              var fontSize = (height / 128).toFixed(2);
              ctx.font = fontSize + "em sans-serif";
              ctx.textBaseline = "middle";

              ctx.save();
            } else {
              ctx
            }
          }
        }
      }
    ]
  )
};

export function setupChartHook() {
  return {
    hasLegend() {
      return JSON.parse(this.el.dataset.legend);
    },
    results() {
      return JSON.parse(this.el.dataset.results);
    },
    total() {
      return this.results().reduce(reducer);
    },
    totalTagged() {
      return this.el.dataset.tagged;
    },
    totalEntries() {
      return this.el.dataset.entries;
    },
    labels() {
      return JSON.parse(this.el.dataset.labels);
    },
    chartType() {
      return JSON.parse(this.el.dataset.charttype);
    },
    config() {
      let chartType = this.chartType();
      if (chartType == "column") {
        chartType = 'bar';
      }

      return {
        type: chartType,
        data: chartConfig(this),
        options: chartOptions(this),
      }
    },
    currentChart: 15,
    getCurrentChart() {
      this.currentChart;
    },
    setCurrentChart(chart) {
      this.currentChart = chart;
    },
    chart(ctx, config) {
      this.setCurrentChart(new Chart(ctx, config));

      return this.currentChart;
    },
    mounted() {
      registerChart();
      this.chart(this.el.getContext('2d'), this.config());
      this.handleEvent("rebuild", () => {
        this.currentChart.destroy()
        this.chart(this.el.getContext('2d'), this.config());
      })
    }
  }
};

function chartOptions(dis) {
  if (dis.chartType() == "doughnut") {
    return {
        plugins: {
          legend: {
            display: dis.hasLegend(),
            position: 'left',
            align: 'start',
            maxWidth: 150,
            labels: {
              textAlign: 'left',
            }
          },
          datalabels: {
            backgroundColor: function(context) {
              return context.dataset.backgroundColor;
            },
            borderColor: 'white',
            borderRadius: 25,
            borderWidth: 2,
            padding: 6,
            align: 'end',
            color: 'white',
            display: true,
            font: {
              weight: 'bold'
            },
            formatter: Math.round
          },
        },

        // Core options
        aspectRatio: 4.4 / 3,
        cutoutPercentage: 32,
        layout: {
          padding: {left: 10, right: 0, bottom: 50, top: 50},
          width: 100
        },
        elements: {
          line: {
            fill: true
          },
          point: {
            hoverRadius: 7,
            radius: 5
          }
        }
      }
  } else {
    let barAxis = dis.chartType() == "column" ? 'x' : 'y';

    return {
      indexAxis: barAxis,
      grouped: false,
      plugins: {
        legend: {
          display: false,
        },
        datalabels: {
          backgroundColor: function(context) {
            return context.dataset.backgroundColor;
          },
          borderColor: 'white',
          borderRadius: 25,
          borderWidth: 2,
          padding: 6,
          align: 'end',
          color: 'white',
          display: true,
          font: {
            weight: 'bold'
          },
          formatter: Math.round
        },
      },

      // Core options
      aspectRatio: 4.4 / 3,
      cutoutPercentage: 32,
      layout: {
        padding: {left: 10, right: 100, bottom: 50, top: 50},
        width: 100
      },
      elements: {
        line: {
          fill: true
        },
        point: {
          hoverRadius: 7,
          radius: 5
        }
      }
    }
  }
}

function chartConfig(dis) {
  if (dis.chartType() == "doughnut") {
    return {
        labels: dis.labels(),
        totalTags: dis.total(),
        totalTagged: dis.totalTagged(),
        totalEntries: dis.totalEntries(),
        hasLegend: dis.hasLegend(),
        chartType: dis.chartType(),
        datasets: [
          {
            data: dis.results(),
            backgroundColor: [
              'rgb(244 63 94)',
              'rgb(217 70 239)',
              'rgb(139 92 246)',
              'rgb(59 130 246)',
              'rgb(6 182 212)',
              'rgb(16 185 129)',
              'rgb(132 204 22)',
              'rgb(245 158 11)',
              'rgb(239 68 68)',
              'rgb(236 72 153)',
              'rgb(168 85 247)',
              'rgb(99 102 241)',
              'rgb(14 165 233)',
              'rgb(20 184 166)',
              'rgb(34 197 94)',
              'rgb(234 179 8)',
              'rgb(249 115 22)',
              'rgb(113 113 122)',
              'rgb(100 116 139)'
            ],
            borderColor: 'rgb(75, 192, 192)',
            datalabels: {
              anchor: 'end',
              formatter: (val, ctx) => {
                if (dis.chartType() == "doughnut") {
                  let label = ctx.chart.data.labels[ctx.dataIndex];
                  label = label.substring(0, 20);
                  return `${label} - ${percentage_of(val, dis.total())}% [${percentage_of(val, dis.totalEntries())}% entries]`;
                } else {
                  let label = ctx.chart.data.labels[ctx.dataIndex]
                  return `${percentage_of(val, dis.total())}% [${percentage_of(val, dis.totalEntries())}% entries]`;
                }
              },
            }
          }
        ]
    }
  } else {
    return {
        labels: dis.labels(),
        totalTags: dis.total(),
        totalTagged: dis.totalTagged(),
        totalEntries: dis.totalEntries(),
        hasLegend: false,
        chartType: dis.chartType(),
        grouped: false,
        datasets: [
          {
            data: dis.results(),
            backgroundColor: [
              'rgb(244 63 94)',
              'rgb(217 70 239)',
              'rgb(139 92 246)',
              'rgb(59 130 246)',
              'rgb(6 182 212)',
              'rgb(16 185 129)',
              'rgb(132 204 22)',
              'rgb(245 158 11)',
              'rgb(239 68 68)',
              'rgb(236 72 153)',
              'rgb(168 85 247)',
              'rgb(99 102 241)',
              'rgb(14 165 233)',
              'rgb(20 184 166)',
              'rgb(34 197 94)',
              'rgb(234 179 8)',
              'rgb(249 115 22)',
              'rgb(113 113 122)',
              'rgb(100 116 139)'
            ],
            borderColor: 'rgb(75, 192, 192)',
            datalabels: {
              anchor: 'end',
              formatter: (val, ctx) => {
                if (dis.chartType() == "polarArea") {
                  let label = ctx.chart.data.labels[ctx.dataIndex]
                  return `${label} - ${percentage_of(val, dis.total())}% [${percentage_of(val, dis.totalEntries())}% entries]`;
                } else {
                  let label = ctx.chart.data.labels[ctx.dataIndex]
                  return `${percentage_of(val, dis.total())}% [${percentage_of(val, dis.totalEntries())}% entries]`;
                }
              },
            }
          }
        ]
    }
  }
}
